import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const iconSpriteStyle: React.CSSProperties = {
  width: toPx(sharedStyles.IconSizes.MEDIUM),
  height: toPx(sharedStyles.IconSizes.MEDIUM),
}
